export default "__VITE_ASSET__4c95bb8e__"